<template>
  <section class="content">
    <template v-for="alert in alerts">
      <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
        <h4>
          <i v-if="alert.type == 'success' || alert.type == 'warning' "class="icon fa fa-check"></i>
          <i class="icon fa fa-ban" v-else></i>
          {{'alert_'+alert.type | translate}}!</h4>
        {{alert.message}}
      </b-alert>
    </template>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h2 class="box-title"><i class="fa fa-download mr-5"></i>{{'bookkeeping' | translate}}</h2>
      </div>
      <div class="box-body">
        <table class="table table-hover">
          <thead>
            <tr>
              <th width="30%">{{'action' | translate}}</th>
              <th width="30%">{{'date' | translate}} / {{'period' | translate}}</th>
              <th width="20%">{{'download' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="sde1Active">
              <td>{{'basic_fee_billing' | translate}}</td>
              <td>{{'current_month' | translate}}</td>
              <td>
                <a class="btn btn-success btn-sm" @click="downloadBasicFee">
                  <i class="fa fa-cloud-download mr-5"></i>{{'download_csv' | translate}}
                </a>
              </td>
            </tr>
            <tr v-if="sde1Active">
              <td>{{'dig_shop_window_billing' | translate}}</td>
              <td>{{'current_month' | translate}}</td>
              <td>
                <a class="btn btn-success btn-sm" @click="downloadWindowAccounting">
                  <i class="fa fa-cloud-download mr-5"></i>{{'download_csv' | translate}}
                </a>
              </td>
            </tr>
            <tr v-if="sde1Active">
              <td>{{'click_and_collect_billing' | translate}}</td>
              <td>
                <vue-monthly-picker
                  style="width: 50%"
                  dateFormat="MM-YYYY"
                  class="form-control"
                  v-model="selectedMonth"
                  :max="max"
                  :monthLabels="monthLabels"
                >
                </vue-monthly-picker>
              </td>
              <td>
                <a class="btn btn-success btn-sm text-center" @click="downloadClickCollectAccounting">
                  <i class="fa fa-cloud-download mr-5"></i>{{'download_csv' | translate}}
                </a>
              </td>
            </tr>
            <tr>
              <td>{{'billing_overview' | translate}}</td>
              <td>
                <date-range-picker
                  id="ordertime"
                  style="width: 50%; float: left !important;"
                  :startDate="startRange"
                  @pepe="onDateRangeChanged"
                >
                </date-range-picker>
              </td>
              <td>
                <button
                  class="btn btn-success btn-sm text-center"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Start generating your file in your specified date range"
                  v-if="(this.generatingDownload==false && this.readyForDownload==false) || this.prefixFileName !== this.file_prefix_merchant_order"
                  @click="startMerchantOrderGenerate()"
                >
                  <i class="fa fa-cloud-download mr-5"></i>{{ 'download_csv' | translate }}
                </button>
                <button
                  class="btn btn-success btn-sm text-center"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="generating download ... "
                  v-if="this.generatingDownload==true && this.readyForDownload==false && this.prefixFileName === this.file_prefix_merchant_order"
                  disabled="disabled"
                >
                  <i class="fa fa-spinner fa-spin"></i> {{ 'generating_list' | translate }}
                </button>
                <button
                  class="btn btn-success btn-sm text-center"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Download your file"
                  v-if="this.generatingDownload==false && this.readyForDownload==true && this.prefixFileName === this.file_prefix_merchant_order"
                  @click="downloadFile()"
                >
                  <i class="fa fa-download mr-5"></i> {{ 'ready_to_download' | translate }}
                </button>
              </td>
            </tr>
            <tr>
              <td>{{'brandt_billing_overview' | translate}}</td>
              <td>
                <date-range-picker
                  id="ordertime"
                  style="width: 50%; float: left !important;"
                  :startDate="startRange"
                  @pepe="onDateRangeChanged"
                >
                </date-range-picker>
              </td>
              <td>
                <button
                  class="btn btn-success btn-sm text-center"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Start generating your file in your specified date range"
                  v-if="(this.generatingDownload==false && this.readyForDownload==false) || this.prefixFileName !== this.file_prefix_merchant_order_brandt"
                  @click="startMerchantOrderBrandtGenerate()"
                >
                  <i class="fa fa-cloud-download mr-5"></i> {{ 'download_csv' | translate }}
                </button>
                <button
                  class="btn btn-success btn-sm text-center"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="generating download ... "
                  v-if="this.generatingDownload==true && this.readyForDownload==false && this.prefixFileName === this.file_prefix_merchant_order_brandt"
                  disabled="disabled"
                >
                   <i class="fa fa-spinner fa-spin"></i> {{ 'generating_list' | translate }}
                </button>
                <button
                  class="btn btn-success btn-sm text-center"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Download your file"
                  v-if="this.generatingDownload==false && this.readyForDownload==true && this.prefixFileName === this.file_prefix_merchant_order_brandt"
                  @click="downloadFile()"
                >
                  <i class="fa fa-download mr-5"></i> {{ 'ready_to_download' | translate }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="box box-primary" v-if="sde1Active">
      <div class="box-header with-border">
        <h2 class="box-title"><i class="fa fa-download mr-5"></i>{{'newsletter' | translate}}</h2>
      </div>
      <div class="box-body">
        <table class="table table-hover">
          <thead>
            <tr>
              <th width="30%">{{'action' | translate}}</th>
              <th width="30%">{{'date' | translate}} / {{'period' | translate}}</th>
              <th width="20%">{{'download' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{'newsletter_signups' | translate}}</td>
              <td>{{'current_month' | translate}}</td>
              <td>
                <a class="btn btn-success btn-sm" @click="downloadNewsletterSubs">
                  <i class="fa fa-cloud-download mr-5"></i>{{'download_csv' | translate}}
                </a>
              </td>
            </tr>
            <tr>
              <td>{{'blacklist_emails' | translate}}</td>
              <td>{{'current_month' | translate}}</td>
              <td>
                <a class="btn btn-success btn-sm" @click="downloadNewsletterBlacklist">
                  <i class="fa fa-cloud-download mr-5"></i>{{'download_csv' | translate}}
                </a>
              </td>
            </tr>
            <tr>
              <td>{{'newsletter_unsubscribes_from_orders' | translate}}</td>
              <td>
                <datepicker
                  style="width: 50%"
                  placeholder="Datum wählen"
                  input-class="form-control pepe"
                  calendar-class="datepicker"
                  v-model="newsletterUnsubDate"
                  format="dd-MM-yyyy"
                >
                </datepicker>
              </td>
              <td>
                <a class="btn btn-success btn-sm" @click="downloadNewsletterUnsubs">
                  <i class="fa fa-cloud-download mr-5"></i>{{'download_csv' | translate}}
                </a>
              </td>
            </tr>
            <tr>
              <td>{{'latest_emails_for_newsletter_distribution' | translate}}</td>
              <td>
                <datepicker
                  style="width: 50%"
                  input-class="form-control pepe"
                  calendar-class="datepicker"
                  v-model="newsletterAddressesDate"
                  format="dd-MM-yyyy"
                >
                </datepicker>
              </td>
              <td>
                <a class="btn btn-success btn-sm" @click="downloadNewsletterAddresses">
                  <i class="fa fa-cloud-download mr-5"></i>{{ 'download_csv' | translate }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
  import VueMonthlyPicker from "vue-monthly-picker";
  import DateRangePicker from '../tools/DateRangePicker'
  import {sde1Active} from '@/sunset-helper'
  export default {
    data() {
      let date = new Date();
      return {
        alerts: [],
        newsletterUnsubDate: date,
        newsletterAddressesDate: date,
        max: moment,
        selectedMonth: moment(),
        monthLabels: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
        startRange: moment().subtract(1, 'month'),
        endRange: moment(),
        readyForDownload: false,
        generatingDownload: false,
        file_prefix_merchant_order_brandt: 'merchant_order_brandt_',
        file_prefix_merchant_order: 'merchant_order_',
        prefixFileName: ''

      }
    },
    components: {
      VueMonthlyPicker: VueMonthlyPicker,
      dateRangePicker: DateRangePicker
    },
    computed: {
      sde1Active
    },
    methods: {
      onDateRangeChanged (picker) {
        this.dateRange = `${picker.startDate} - ${picker.endDate}`
        this.startRange = picker.startDate
        this.endRange = picker.endDate
        this.generatingDownload = false
        this.readyForDownload = false
        this.prefixFileName = ''
      },
      downloadBasicFee() {
        let downloadUrl = 'schuhede/basicFees'
        API.get(downloadUrl)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              let link = document.createElement('a');
              link.setAttribute('href', response.data)
              document.body.appendChild(link)
              link.click()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          })
      },
      downloadWindowAccounting() {
        let downloadUrl = 'schuhede/windowAccounting'
        API.get(downloadUrl)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              let link = document.createElement('a');
              link.setAttribute('href', response.data)
              document.body.appendChild(link)
              link.click()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          })
      },
      downloadNewsletterSubs() {
        let downloadUrl = 'schuhede/newsletterSubs'
        API.get(downloadUrl)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              let link = document.createElement('a');
              link.setAttribute('href', response.data)
              document.body.appendChild(link)
              link.click()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          })
      },
      downloadNewsletterBlacklist() {
        let downloadUrl = 'schuhede/newsletterBlacklist'
        API.get(downloadUrl)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              let link = document.createElement('a');
              link.setAttribute('href', response.data)
              document.body.appendChild(link)
              link.click()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          })
      },
      downloadClickCollectAccounting() {
        let downloadUrl = `schuhede/clickCollectAccounting?month=${this.selectedMonth.month()+1}&year=${this.selectedMonth.year()}`
        API.get(downloadUrl)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              let link = document.createElement('a');
              link.setAttribute('href', response.data)
              document.body.appendChild(link)
              link.click()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          })
      },
      downloadNewsletterUnsubs() {
        let downloadUrl = `schuhede/newsletterUnsubs?date=${moment(this.newsletterUnsubDate).format('YYYY-MM-DD')}`
        API.get(downloadUrl)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              let link = document.createElement('a');
              link.setAttribute('href', response.data)
              document.body.appendChild(link)
              link.click()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          })
      },
      downloadNewsletterAddresses() {
        let downloadUrl = `schuhede/newsletterAddresses?date=${moment(this.newsletterAddressesDate).format('YYYY-MM-DD')}`
        API.get(downloadUrl)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              let link = document.createElement('a');
              link.setAttribute('href', response.data)
              document.body.appendChild(link)
              link.click()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          })
      },
      startMerchantOrderGenerate () {
        let dateFrom = this.startRange.format('YYYY-MM-DD')
        let dateTo = `&date_to=${this.endRange.format('YYYY-MM-DD')}`
        this.generatingDownload = true
        this.prefixFileName = this.file_prefix_merchant_order

        API.get(`schuhede/merchantOrders?date_from=${dateFrom}${dateTo}`)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              this.fileName = response.data.fileName
              this.checkForFileFinished()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          }).catch(error => {
            this.generatingDownload = false
            this.prefixFileName = ''
          let alert = {type: 'danger', dismiss: 4, message: error}
            this.alerts.push(alert)
        })
      },
      startMerchantOrderBrandtGenerate () {
        let dateFrom = this.startRange.format('YYYY-MM-DD')
        let dateTo = `&date_to=${this.endRange.format('YYYY-MM-DD')}`
        this.generatingDownload = true
        this.prefixFileName = this.file_prefix_merchant_order_brandt

        API.get(`schuhede/merchantOrdersBrandt?date_from=${dateFrom}${dateTo}`)
          .then(response => {
            if (response.data !== 'NOTHING TO DO') {
              this.fileName = response.data.fileName
              this.checkForFileFinished()
            } else {
              let alert = {type: 'danger', dismiss: 4, message: "ES KONNTE KEINE DATEI HERUNTERGELADEN WERDEN"}
              this.alerts.push(alert)
            }
          }).catch(error => {
            this.generatingDownload = false
            this.prefixFileName = ''
            let alert = {type: 'danger', dismiss: 4, message: error}
            this.alerts.push(alert)
        })
      },
      checkForFileFinished () {
        var counter = 0
        let interval = setInterval(() => {

          if (counter === 50) {
            clearInterval(interval)
            this.generatingDownload = false
            this.readyForDownload = false
            let alert = {type: 'danger', dismiss: 4, message: "Time Out, no File found"}
            this.alerts.push(alert)
          }
          API.get(`schuhede/download/checkFile?fileName=${this.fileName}`)
            .then(response => {
              if (response.data.readyToDownload === true) {
                this.readyForDownload = true
                this.generatingDownload = false
                clearInterval(interval)
              }
            }).catch(error => {
              this.generatingDownload = false
              clearInterval(interval)
              let alert = {type: 'danger', dismiss: 4, message: error}
              this.alerts.push(alert)
          })
          counter++
        }, 2000)
      },
      downloadFile () {
        let startDate = this.startRange.format('YYYY-MM-DD');
        let endDate = this.endRange.format('YYYY-MM-DD');
        let downloadFileName = this.prefixFileName + startDate + '_' + endDate + '.csv';
        API.get(`schuhede/download/downloadFile?fileName=${this.fileName}&downloadName=${downloadFileName}`)
          .then(response => {
            let encodedUri = response.data
            let link = document.createElement('a')
            link.setAttribute('href', encodedUri)
            link.setAttribute('download', downloadFileName)
            document.body.appendChild(link)
            link.click()
            this.generatingDownload = false
            this.prefixFileName = ''
          }).catch(error => {
          this.generatingDownload = false
          let alert = {type: 'danger', dismiss: 4, message: error}
          this.alerts.push(alert)
        })
      }
    }
  }
</script>
<style>
  select option.normal{
    margin:40px;
    color:#fff;
    text-shadow:0 1px 0 rgba(0,0,0,.4);
    background:#202227
  }
  .picker:not(.month-year-label) {
    background: #212228;
  }
  .picker > .flexbox:not(.monthItem) {
    background-color: rgba(0,195,150,.075);
    border-color: #00C396;
    color: #00C396;
    font-weight: 600;
  }
  .picker > .flexbox.monthItem {
    background-color: #212228 ;
    color: white;
    border-top: 1px solid rgba(255,255,255, .15) !important;
  }
  .picker .monthItem .item:hover {
    background-color: #00C396 !important;
  }
  .date-popover{
    background: none !important;
    border: 1px solid rgba(255,255,255, .15) !important
  }
  .datepicker {
    color: white;
    background-color: #212228;
    border: 1px solid rgba(255, 255, 255, .15);
  }
  .vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover {
    background-color: #00c396;
  }
  .vdp-datepicker__calendar .cell.selected {
    background-color: #00c396;
  }
  .pepe {
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/SchuheDeFileDownload.vue